import { render, staticRenderFns } from "./password-validate.vue?vue&type=template&id=635b939c&scoped=true"
import script from "./password-validate.ts?vue&type=script&lang=ts&external"
export * from "./password-validate.ts?vue&type=script&lang=ts&external"
import style0 from "./password-validate.scss?vue&type=style&index=0&id=635b939c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b939c",
  null
  
)

export default component.exports